<!-- params: {{ params | json }} <br />
get: {{ get | json }} -->

<div *ngIf="!!get" class="col-xs-12 sp-0">
    <tt-card class="col-xs-6 sp-5">
        <!-- <tt-input ttLabel="charge_keyno" [ttModel]="get.charge_keyno" ttReadonly></tt-input>
    <tt-input ttLabel="chargetest_keyno" [ttModel]="get.chargetest_keyno" ttReadonly></tt-input> -->
        <tt-input ttLabel="charge_id" [ttModel]="get.charge_id" ttReadonly></tt-input>
        <tt-input-number ttLabel="test_no" [(ttModel)]="get.test_no" ttTextAlign="right"></tt-input-number>
        <tt-input ttLabel="testcode" [(ttModel)]="get.testcode"></tt-input>
        <tt-input-number ttLabel="yield_point" [(ttModel)]="get.yield_point" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="tensile_strength" [(ttModel)]="get.tensile_strength" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="elongation" [(ttModel)]="get.elongation" ttDecimals="1" ttTextAlign="right"></tt-input-number>
        <tt-input-number ttLabel="contraction" [(ttModel)]="get.contraction" ttTextAlign="right"></tt-input-number>
        <tt-input ttLabel="impact" [(ttModel)]="get.impact"></tt-input>
        <tt-input-number ttLabel="temperature_c" [(ttModel)]="get.temperature_c" ttTextAlign="right"></tt-input-number>
        <tt-input ttLabel="dimension" [(ttModel)]="get.dimension"></tt-input>
        <tt-textarea ttLabel="note" [(ttModel)]="get.note"></tt-textarea>
        <tt-checkbox ttLabel="is_hidden" [(ttModel)]="get.is_hidden"></tt-checkbox>
        <tt-button-save (ttClick)="save()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
    <tt-card class="col-xs-6 sp-5">
        <tt-input ttLabel="reg_by_portal_user_name" [ttModel]="get.reg_by_portal_user_name" ttReadonly></tt-input>
        <tt-datetime ttLabel="reg_datetime" [ttModel]="get.reg_datetime" ttReadonly></tt-datetime>
        <tt-input ttLabel="mod_by_portal_user_name" [ttModel]="get.mod_by_portal_user_name" ttReadonly></tt-input>
        <tt-datetime ttLabel="mod_datetime" [ttModel]="get.mod_datetime" ttReadonly></tt-datetime>
    </tt-card>
</div>
